import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {
  CustomerOpportunity,
  CustomerUser,
  GetAccountDetailsFromSfFn,
  GetOpportunitiesForCustomerFn,
  SfAccountDetails,
  PismoAccountMapping,
  PismoProgram,
  GetRbaRateFn,
  OverdraftAccountActionsDialogData,
  OverdraftAccountActionsDialogResult,
  GetCustomerFn,
  PismoGetAccountResponse,
  OverdraftAccountLimitIncreaseFn,
  OverdraftAccountLimitIncreaseResponse,
  OverdraftAccountLimitDecreaseFn,
  OverdraftAccountLimitDecreaseResponse,
  OverdraftAccountRenewalFn,
  OverdraftAccountRenewalResponse,
  PayloadApiResponse,
  GetApplicationBySalesforceIdFn,
  Application,
} from '@portal-workspace/grow-shared-library';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatChipsModule } from '@angular/material/chips';
import { combineLatest, Subscription, tap } from 'rxjs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatTableModule } from '@angular/material/table';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { NgTemplateOutlet, DecimalPipe } from '@angular/common';
import { ApplicationStepper2Component } from '../application-stepper-component/application-stepper2.component';
import {
  setupUntilDestroy,
  PortalHotToastService,
  ApplicationDialogService,
  setPrevNextButtonVisibilityFn, setSecondaryButtonFn, setSecondaryButtonText,
  setStepper2StepConfig,
  formControlErrorKeys, formControlErrorMessage,
} from '@portal-workspace/grow-ui-library';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { BpayBankDetailsComponent } from '../bpay-bank-details-component/bpay-bank-details.component';
import { LocalBankAccountDetailComponent } from '../local-bank-account-detail-component/local-bank-account-detail.component';
import {PercentagePipe} from '../../pipes/percentage.pipe';
import {MessageBox2Component} from '../message-box/message-box-2.component';
@UntilDestroy()
@Component({
    templateUrl: './overdraft-account-actions.dialog.html',
    styleUrls: ['./overdraft-account-actions.dialog.scss'],
    standalone: true,
    imports: [ApplicationStepper2Component, CdkStepperModule, MatOptionModule, MatSelectModule, NgTemplateOutlet, FormsModule, MatButtonModule, ReactiveFormsModule, FlexModule, MatTooltipModule, MatFormFieldModule, MatInputModule, InputMaskModule, MatTableModule, MatCheckboxModule, MatChipsModule, PdfViewerModule, DecimalPipe, LooseCurrencyPipe, MatDialogModule, BpayBankDetailsComponent, LocalBankAccountDetailComponent,PercentagePipe, MessageBox2Component]
})
export class OverdraftAccountActionsDialog implements OnInit{

  getOpportunitiesForCustomerFn!: GetOpportunitiesForCustomerFn;
  getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  getApplicationBySalesforceIdFn!: GetApplicationBySalesforceIdFn;
  getRbaRateFn!: GetRbaRateFn;
  getCustomerFn!: GetCustomerFn;
  overdraftAccountLimitIncreaseFn!: OverdraftAccountLimitIncreaseFn;
  overdraftAccountLimitDecreaseFn!: OverdraftAccountLimitDecreaseFn;
  overdraftAccountRenewalFn!: OverdraftAccountRenewalFn;
  customer: CustomerUser | null = null;
  savedApplication: Application | null = null;
  actionType: 'increase' | 'decrease' | 'renewal' | 'increase+renewal' | 'decrease+renewal' = 'increase';
  termRenewal: boolean = false;
  opportunitySelections: CustomerOpportunity[] = [];
  programSelections : PismoProgram[] = [];
  subscriptions: Subscription[] = [];
  existingPismoAccountMappings: PismoAccountMapping[] = [];
  customerSfDetails!: SfAccountDetails;
  brokerSfDetails!: SfAccountDetails;
  pismoAccountDetails!: PismoGetAccountResponse;
  selectedOpportunity: CustomerOpportunity | null = null;
  
   
  setSecondaryButtonText = setSecondaryButtonText;
 

  setSecondaryButtonFn = setSecondaryButtonFn;
  setPrevNextButtonVisibilityFn = setPrevNextButtonVisibilityFn;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  // step 1
  formGroupStep1!: FormGroup;
  formControlStep1Opportunity!: FormControl<CustomerOpportunity | null>;

  // step 2
  formGroupStep2!: FormGroup;
  formControlStep2OverdraftLimit!: FormControl<number | null>;
  formControlStep2Rate!: FormControl<number | null>;
  formControlStep2Margin!: FormControl<number | null>;
  formControlStep2DocFee!: FormControl<number| null>;
  formControlStep2DocFeeFinanced!: FormControl<boolean | null>;
  formControlStep2FacilityEstablishmentFee!: FormControl<number| null>;
  formControlStep2Brokerage!: FormControl<number| null>;
  formControlStep2CustomerName!: FormControl<string | null>;
  formControlStep2CustomerAccountName!: FormControl<string | null>;
  formControlStep2CustomerBsb!: FormControl<string | null>;
  formControlStep2CustomerAccountNumber!: FormControl<string | null>;
  formControlStep2CustomerFinancialInstitutionName!: FormControl<string | null>;
  formControlStep2BrokerName!: FormControl<string | null>;
  formControlStep2BrokerAccountName!: FormControl<string | null>;
  formControlStep2BrokerBsb!: FormControl<string | null>;
  formControlStep2BrokerAccountNumber!: FormControl<string | null>;
  formControlStep2BrokerFinancialInstitutionName!: FormControl<string | null>;
  feePostingStatusStep2 = false;
  limitIncreaseResponse!: OverdraftAccountLimitIncreaseResponse;
  limitDecreaseResponse!: OverdraftAccountLimitDecreaseResponse;
  renewalResponse!: OverdraftAccountRenewalResponse;
  earlyTerminationFee: number = 0;
  apiError: boolean = false;
  apiErrorMessage: string = '';

  // step 3
  formGroupStep3!: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: OverdraftAccountActionsDialogData,
    private dialogRef: MatDialogRef<OverdraftAccountActionsDialog, OverdraftAccountActionsDialogResult>,
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
    private applicationDialogService: ApplicationDialogService,
  ) {
      this.getOpportunitiesForCustomerFn = data.getOpportunitiesForCustomerFn;
      this.getAccountDetailsFromSfFn = data.getAccountDetailsFromSfFn;
      this.getRbaRateFn = data.getRbaRateFn;
      this.getCustomerFn = data.getCustomerFn;
      this.overdraftAccountLimitIncreaseFn = data.overdraftAccountLimitIncreaseFn;
      if ('overdraftAccountLimitDecreaseFn' in data) {
        this.overdraftAccountLimitDecreaseFn = data.overdraftAccountLimitDecreaseFn;
        this.overdraftAccountRenewalFn = data.overdraftAccountRenewalFn;
        this.getApplicationBySalesforceIdFn = data.getApplicationBySalesforceIdFn;
      }
      this.pismoAccountDetails = data.pismoAccountDetails;
  }

  ngOnInit(): void {
    setupUntilDestroy(this);

    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.populate();
  }

  populate() {
    this.subscriptions.push(this.getCustomerFn(this.data.customerId).pipe(
      this.toastService.spinnerObservable(),
      tap(r => {
       this.customer = r;
       if (this.customer && this.customer.SalesforceId) {
           this.subscriptions.push(
             this.getOpportunitiesForCustomerFn(this.customer.SalesforceId).pipe(
                 this.toastService.spinnerObservable(),
             ).subscribe((opportunities: CustomerOpportunity[]) => {
               this.opportunitySelections = opportunities.filter(o => o.RecordTypeId === this.data.overdraftCustomerSfRecordId && o.Stage === this.data.overdraftSfOpportunityStage);
               console.log('this.opportunitySelections: ', this.opportunitySelections);
             })
           )
       }
     })
    ).subscribe());
  }

  getActionTypeLabel(): string {
    switch (this.actionType) {
      case 'increase':
        return 'Limit Increase';
      case 'decrease':
        return 'Limit Decrease';
      case 'renewal':
        return 'Renewal';
      case 'increase+renewal':
        return 'Limit Increase + Renewal';
      case 'decrease+renewal':
        return 'Limit Decrease + Renewal';
      default:
        return 'Account Action';
    }
  }

  getLimitChangeLabel(): string {
    return 'New Limit';
  }

  getCurrentLimit(): number {
    return this.pismoAccountDetails?.max_credit_limit ?? 0;
  }

  getLimitChangeDelta(): number {
    const newLimit = this.formControlStep2OverdraftLimit.value ?? 0;
    const currentLimit = this.getCurrentLimit();
    
    if (this.actionType === 'decrease' || this.actionType === 'decrease+renewal') {
      return currentLimit - newLimit; // Positive number representing decrease
    } else {
      return newLimit - currentLimit; // Positive number representing increase
    }
  }

  getSuccessMessage(): string {
    const isPartial = this.hasFailedFees();
    const prefix = isPartial ? 'Partially Successful: ' : '';
    const suffix = isPartial ? ' (some secondary tasks failed)' : ' successfully';

    switch (this.actionType) {
      case 'increase':
        return `${prefix}Overdraft account limit has been increased${suffix}`;
      case 'decrease':
        return `${prefix}Overdraft account limit has been decreased${suffix}`;
      case 'renewal':
        return `${prefix}Overdraft account has been renewed${suffix}`;
      case 'increase+renewal':
        return `${prefix}Overdraft account limit has been increased and renewed${suffix}`;
      case 'decrease+renewal':
        return `${prefix}Overdraft account limit has been decreased and renewed${suffix}`;
      default:
        return `${prefix}Account action completed${suffix}`;
    }
  }

  initStep1() {
    this.formControlStep1Opportunity = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep1 = this.formBuilder.group({
      opportunity: this.formControlStep1Opportunity,
    });

    // Watch for opportunity selection changes to determine action type
    this.subscriptions.push(
      this.formControlStep1Opportunity.valueChanges.subscribe((opportunity: CustomerOpportunity | null) => {
        if (opportunity && this.getApplicationBySalesforceIdFn) {
          this.selectedOpportunity = opportunity;
          const loanPurpose = opportunity.LoanPurpose;
          
          // Fetch application to get TermRenewal from saved application
          this.subscriptions.push(
            this.getApplicationBySalesforceIdFn(opportunity.SalesforceId).subscribe(application => {
              this.savedApplication = application;
              
              if (this.savedApplication && this.savedApplication.ApplicationType === 'BusinessOverdraft') {
                // Extract TermRenewal from saved application
                const pricingDetails = this.savedApplication.PricingDetails as any;
                this.termRenewal = pricingDetails?.TermRenewal === 'Yes';
                this.earlyTerminationFee = pricingDetails?.EarlyTerminationFee ?? 0;
              } else {
                this.termRenewal = false;
              }
              
              // Determine action type based on loan purpose and termRenewal
              if (loanPurpose === 'Limit Increase') {
                this.actionType = this.termRenewal ? 'increase+renewal' : 'increase';
              } else if (loanPurpose === 'Limit Decrease') {
                this.actionType = this.termRenewal ? 'decrease+renewal' : 'decrease';
              } else if (loanPurpose === 'Renewal') {
                this.actionType = 'renewal';
              } else {
                this.actionType = 'increase'; // default
              }
            })
          );
        }
      })
    );

    setStepper2StepConfig(this.formGroupStep1, {
      previousStepButtonText:"Close",
      previousStepClickedFn: async (stepper) => {
        this.onClickClose()
      },
      nextStepClickedFn: async stepper => {
        if (this.formGroupStep1.valid) {
          const opportunity = this.formControlStep1Opportunity.value as CustomerOpportunity;
  
          this.subscriptions.push(
            combineLatest([
              this.getAccountDetailsFromSfFn(this.customer?.SalesforceId ?? ''),
              this.getAccountDetailsFromSfFn(this.formControlStep1Opportunity.value?.BrokerSalesforceId ?? ''),
              this.getRbaRateFn(),
            ]).pipe(
              this.toastService.spinnerObservable(),
            ).subscribe(([customerDetails, brokerDetails, rbaRate]: [SfAccountDetails, SfAccountDetails, number]) => {
              console.log('======customersfDetails: ', customerDetails);
              console.log('======brokerDetails: ', brokerDetails);
              console.log('======rbaRate: ', rbaRate);
              this.customerSfDetails = customerDetails;
              this.brokerSfDetails = brokerDetails;
              this.formControlStep2CustomerName.setValue(customerDetails.Name);
              // use bank details on the opportunity level
              if (opportunity.BankAccountNumber) {
                this.formControlStep2CustomerAccountName.setValue(opportunity.BankAccountName);
                this.formControlStep2CustomerBsb.setValue(opportunity.BankAccountBsb);
                this.formControlStep2CustomerAccountNumber.setValue(opportunity.BankAccountNumber);
                this.formControlStep2CustomerFinancialInstitutionName.setValue(opportunity.FinancialInstitutionName);
              } else { // if no bank details on the opportunity level, we use the bank details on account level
                this.formControlStep2CustomerAccountName.setValue(customerDetails.AccountName);
                this.formControlStep2CustomerBsb.setValue(customerDetails.BSB);
                this.formControlStep2CustomerAccountNumber.setValue(customerDetails.AccountNumber);
                this.formControlStep2CustomerFinancialInstitutionName.setValue(customerDetails.InstitutionName);
              }
  
              this.formControlStep2BrokerName.setValue(brokerDetails.Name);
              this.formControlStep2BrokerAccountName.setValue(brokerDetails.AccountName);
              this.formControlStep2BrokerBsb.setValue(brokerDetails.BSB);
              this.formControlStep2BrokerAccountNumber.setValue(brokerDetails.AccountNumber);
              this.formControlStep2BrokerFinancialInstitutionName.setValue(brokerDetails.InstitutionName);
  
              this.formControlStep2OverdraftLimit.setValue(opportunity.Amount);
              this.formControlStep2Margin.setValue(opportunity.Margin);
              this.formControlStep2Rate.setValue((opportunity.Margin ?? 0) + rbaRate);
              this.formControlStep2DocFee.setValue(opportunity.DocFee);
              this.formControlStep2DocFeeFinanced.setValue(opportunity.DocFeeFinanced);
              this.formControlStep2FacilityEstablishmentFee.setValue(opportunity.FacilityEstablishmentFee);
              this.formControlStep2Brokerage.setValue(opportunity.Brokerage);
              
              // Action type and termRenewal already determined in valueChanges handler above
              
              stepper.next();
            })
          )
        }
      },
    });

    
    this.setPrevNextButtonVisibilityFn(this.formGroupStep1, false, true);
  }

  initStep2() {
    this.formControlStep2OverdraftLimit = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2Rate = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2Margin = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DocFee = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DocFeeFinanced = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2FacilityEstablishmentFee = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2Brokerage = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2CustomerName = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2CustomerAccountName = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2CustomerBsb = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2CustomerAccountNumber = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2CustomerFinancialInstitutionName = this.formBuilder.control(null);
    this.formControlStep2BrokerName = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2BrokerAccountName = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2BrokerBsb = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2BrokerAccountNumber = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2BrokerFinancialInstitutionName = this.formBuilder.control(null);

    this.formGroupStep2 = this.formBuilder.group({
      limitIncrease: this.formControlStep2OverdraftLimit,
      limitDecrease: this.formControlStep2OverdraftLimit,
      rate: this.formControlStep2Rate,
      margin: this.formControlStep2Margin,
      docFee: this.formControlStep2DocFee,
      docFeeFinanced: this.formControlStep2DocFeeFinanced,
      facilityEstablishmentFee: this.formControlStep2FacilityEstablishmentFee,
      brokerage: this.formControlStep2Brokerage,
      //customerName: this.formControlStep2CustomerName,
      customerAccountName: this.formControlStep2CustomerAccountName,
      customerBsb: this.formControlStep2CustomerBsb,
      customerAccountNumber: this.formControlStep2CustomerAccountNumber,
      customerFinancialInstitutionName: this.formControlStep2CustomerFinancialInstitutionName,
      brokerName: this.formControlStep2BrokerName,
      brokerAccountName: this.formControlStep2BrokerAccountName,
      brokerBsb: this.formControlStep2BrokerBsb,
      brokerAccountNumber: this.formControlStep2BrokerAccountNumber,
      brokerFinancialInstitutionName: this.formControlStep2BrokerFinancialInstitutionName,
    });

    setStepper2StepConfig(this.formGroupStep2, {
      nextStepClickedFn: async stepper => {
        console.log(this.formGroupStep2.value);
          if (!this.customer) {
            this.applicationDialogService.openAlertDialog({
              message: `Warning`,
              subMessage: `Failed to load customer details.`,
            })
            return;
          }

          this.processAccountAction(stepper);
      },
    });

    
   
  }

  initStep3() {
    this.formGroupStep3 = this.formBuilder.group({});
    this.setPrevNextButtonVisibilityFn(this.formGroupStep3, false, true);
    setStepper2StepConfig(this.formGroupStep3, {
      nextStepButtonText: 'Got it',
      nextStepClickedFn: async stepper => {
        this.dialogRef.close({
          readyForSubmission: true
        });
      },
    });
    
  }

  onClickClose() {
    this.dialogRef.close();
  }

  processAccountAction(stepper: CdkStepper) {
    if (!this.customer || !this.formControlStep1Opportunity.value) {
      this.applicationDialogService.openAlertDialog({
        message: `Warning`,
        subMessage: `You cannot process the account action because you have missing information.`,
      });
      return;
    }

    const opportunity = this.formControlStep1Opportunity.value as CustomerOpportunity;
    const formData = this.formGroupStep2.value;
    
    const currentLimit = this.pismoAccountDetails.max_credit_limit;
    const newLimit = formData.limitIncrease || formData.limitDecrease || 0;
    
    // Handle limit increase
    if (this.actionType === 'increase' || this.actionType === 'increase+renewal') {
      // Calculate delta: newLimit - currentLimit
      const limitIncreaseDelta = newLimit - currentLimit;
      
      this.subscriptions.push(
        this.overdraftAccountLimitIncreaseFn({
          data: { ...formData, limitIncrease: limitIncreaseDelta, earlyTerminationFee: this.earlyTerminationFee },
          pismoAccountId: this.pismoAccountDetails.account_id,
          pismoAccountDetails: this.pismoAccountDetails,
          customer: this.customer,
          opportunityId: opportunity.SalesforceId,
          termRenewal: this.termRenewal,
        }).pipe(
          this.toastService.spinnerObservable(),
        ).subscribe({
          next: (result: PayloadApiResponse<OverdraftAccountLimitIncreaseResponse>) => {
            console.log('=====limit increase result: ', result);
            if (result) {
              this.feePostingStatusStep2 = result.status;
              this.limitIncreaseResponse = result.payload;
            }
            // Renewal is already handled by the limit increase endpoint via termRenewal flag
            stepper.next();
          },
          error: (err) => {
            console.error('Limit increase error:', err);
            this.handleApiError(err, 'Limit Increase');
          }
        })
      );
    }
    // Handle limit decrease
    else if (this.actionType === 'decrease' || this.actionType === 'decrease+renewal') {
      // Calculate delta: currentLimit - newLimit
      const limitDecreaseDelta = currentLimit - newLimit;
      
      this.subscriptions.push(
        this.overdraftAccountLimitDecreaseFn({
          data: { ...formData, limitDecrease: limitDecreaseDelta, earlyTerminationFee: this.earlyTerminationFee },
          pismoAccountId: this.pismoAccountDetails.account_id,
          pismoAccountDetails: this.pismoAccountDetails,
          customer: this.customer,
          opportunityId: opportunity.SalesforceId,
          termRenewal: this.termRenewal,
        }).pipe(
          this.toastService.spinnerObservable(),
        ).subscribe({
          next: (result: PayloadApiResponse<OverdraftAccountLimitDecreaseResponse>) => {
            console.log('=====limit decrease result: ', result);
            if (result) {
              this.feePostingStatusStep2 = result.status;
              this.limitDecreaseResponse = result.payload;
            }
            // Renewal is already handled by the limit decrease endpoint via termRenewal flag
            stepper.next();
          },
          error: (err) => {
            console.error('Limit decrease error:', err);
            this.handleApiError(err, 'Limit Decrease');
          }
        })
      );
    }
    // Handle renewal only
    else if (this.actionType === 'renewal') {
      this.processRenewal(stepper, this.earlyTerminationFee);
    }
  }

  processRenewal(stepper: CdkStepper, earlyTerminationFee: number = 0) {
    if (!this.customer || !this.formControlStep1Opportunity.value) {
      return;
    }

    const opportunity = this.formControlStep1Opportunity.value as CustomerOpportunity;
    const formData = this.formGroupStep2.value;
    
    this.subscriptions.push(
      this.overdraftAccountRenewalFn({
        data: {
          rate: formData.rate,
          margin: formData.margin,
          docFee: formData.docFee,
          docFeeFinanced: formData.docFeeFinanced,
          facilityEstablishmentFee: formData.facilityEstablishmentFee,
          brokerage: formData.brokerage,
          earlyTerminationFee: earlyTerminationFee,
          customerAccountName: formData.customerAccountName,
          customerBsb: formData.customerBsb,
          customerAccountNumber: formData.customerAccountNumber,
          customerFinancialInstitutionName: formData.customerFinancialInstitutionName,
          brokerName: formData.brokerName,
          brokerAccountName: formData.brokerAccountName,
          brokerBsb: formData.brokerBsb,
          brokerAccountNumber: formData.brokerAccountNumber,
          brokerFinancialInstitutionName: formData.brokerFinancialInstitutionName,
        },
        pismoAccountId: this.pismoAccountDetails.account_id,
        pismoAccountDetails: this.pismoAccountDetails,
        customer: this.customer,
        opportunityId: opportunity.SalesforceId,
      }).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe({
        next: (result: PayloadApiResponse<OverdraftAccountRenewalResponse>) => {
          console.log('=====renewal result: ', result);
          if (result) {
            this.feePostingStatusStep2 = result.status;
            this.renewalResponse = result.payload;
          }
          stepper.next();
        },
        error: (err) => {
          console.error('Renewal error:', err);
          this.handleApiError(err, 'Renewal');
        }
      })
    );
  }

  get failedFeePostingMessage() {
    const response = this.limitIncreaseResponse || this.limitDecreaseResponse || this.renewalResponse;
    if (!this.feePostingStatusStep2 && response) {
      const failedFees = this.getFailedFeesList();
      return failedFees.join(', ');
    } 

    return '';
  }

  getFailedFeesList(): string[] {
    const response = this.limitIncreaseResponse || this.limitDecreaseResponse || this.renewalResponse;
    if (!response) return [];

    const feeLabels: { [key: string]: string } = {
      facilityEstablishmentFeeStatus: 'Facility Establishment Fee',
      brokerageStatus: 'Brokerage',
      documentationFeeStatus: 'Documentation Fee',
      documentationFeeReversalStatus: 'Documentation Fee Reversal',
      earlyTerminationFeeStatus: 'Early Termination Fee',
      saveAccountInterestRateStatus: 'Interest Rate Update',
      updateAccountMetadata: 'Account Metadata Update',
      syncToSfStatus: 'Salesforce Sync',
      updateAccountLimit: 'Account Limit Update'
    };

    const failedFees: string[] = [];
    for (const key of Object.keys(response)) {
      if (!(response as any)[key] && feeLabels[key]) {
        failedFees.push(feeLabels[key]);
      }
    }

    return failedFees;
  }

  hasFailedFees(): boolean {
    return !this.feePostingStatusStep2 && this.getFailedFeesList().length > 0;
  }

  handleApiError(err: any, action: string) {
    this.apiError = true;
    this.apiErrorMessage = err?.error?.message || err?.message || `An error occurred during ${action}. Please try again later.`;
    
    this.applicationDialogService.openAlertDialog({
      message: `Error: ${action} Failed`,
      subMessage: this.apiErrorMessage,
    });
  }
}

